import React from 'react';
import { motion } from 'framer-motion';
import { FiX, FiInfo } from 'react-icons/fi';
import '../styles/GDPRBanner.css';

const GDPRBanner = ({ onAccept }) => {
  return (
    <motion.div
      className="gdpr-banner"
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
    >
      <div className="gdpr-content">
        <div className="gdpr-icon">
          <FiInfo />
        </div>

        <div className="gdpr-text">
          <h3>GDPR & Cookie Compliance</h3>
          <p>
            We respect your privacy. This website uses cookies and similar tracking technologies to enhance your experience, analyze site usage, and assist with marketing efforts. We also comply fully with GDPR regulations. By accepting, you consent to our use of cookies and data processing as outlined in our Privacy Policy.
          </p>
        </div>

        <div className="gdpr-buttons">
          <motion.button
            className="gdpr-accept"
            onClick={onAccept}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            I Accept
          </motion.button>
          <motion.a
            href="#"
            className="gdpr-link"
            whileHover={{ textDecoration: 'underline' }}
          >
            Learn More
          </motion.a>
        </div>

        <motion.button
          className="gdpr-close"
          onClick={onAccept}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          <FiX />
        </motion.button>
      </div>

      {/* Background overlay */}
      <motion.div
        className="gdpr-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
      />
    </motion.div>
  );
};

export default GDPRBanner;
